import { SVGProps } from 'react';

const RotateCcwKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.5 9.5 1 1m0-2-4 4M3 12a9 9 0 1 0 9-9 9.74 9.74 0 0 0-6.74 2.74L3 8m5 0H3V3m9 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default RotateCcwKey;
